/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { connect } from 'react-redux';
import {
    Input, Button, Form, Container, Message, Label
} from 'semantic-ui-react';
import Swal from '#/swal';
import { actions } from './sagaSlice';
import { getExtension } from '#/meta';


const SigantureForm = props => {


    const { uploadSignature, id } = props;

    const [correctFileType, setCorrectFileType] = useState(false);
    const [showFileError, setShowFIleError] = useState(false);
    const [file, setFile] = useState(null);


    const checkFileType = (event, { value }) => {

        //make sure file is a docx file
        const ext = getExtension(value);
        const correctFileTypes = ['jpg', 'png'];

        if (correctFileTypes.includes(ext)) {

            setCorrectFileType(true);
            setShowFIleError(false);
            const file = event.target.files[0];

            const data = new FormData();
            data.append('file', file, file.name);
            data.append('name', file.name);
            setFile(data);

        }
        else {

            setShowFIleError(true);
        }

    };
    const onSubmit = values => {


        uploadSignature({
            userId: id,
            file
        });

        Swal.fire.success();
        props.setModalOpen(false);
    };

    return (
        <Container>

            <FinalForm
                onSubmit={onSubmit}
                render={({
                    handleSubmit, submitting, pristine
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <Message error header='Incorrect file type' content='You can only upload .jpg or .png files'/>
                        <Form.Field>
                            <label htmlFor='file'>Select File</label>
                            <Input type='file' onChange={checkFileType}/>
                            {showFileError && <Label basic color='red' pointing>File type must be .jpg or .png</Label>}
                        </Form.Field>
                        <Form.Field>
                            <Button
                                floated='left'
                                negative
                                style={{ margin: '10px' }}
                                onClick={() => props.setModalOpen(false)}
                            >
                            Cancel
                            </Button>
                            <Button
                                floated='right'
                                positive
                                type='submit'
                                disabled={submitting || !correctFileType}
                                style={{ margin: '10px' }}
                            >
                            Submit
                            </Button>
                        </Form.Field>
                    </Form>
                )}
            />
        </Container>
    );
};


export default connect(({ auth: { id } }) => ({ id }), actions)(SigantureForm);
